import type { ComponentDocMap } from './types'

/**
 * Prop documentation for the `double_kpi_value` component.
 * Keep in sync with DoubleKpiValueProps in src/ui/uiConfig/components/DoubleKpiValue/DoubleKpiValue.types.ts
 */
export const doubleKpiValuePropDocs: ComponentDocMap = {
  items: {
    description: 'Array of KPI groups. Each group can render one main value and optional sub values.',
    type: 'DoubleKpiValueItem[]',
    example:
      '[{ title: "__Revenue", color: "$color-1", values: [{ type: "main", data_id: "revenue", decimals: 0, data_type: "cost" }] }]',
  },
  'items[].title': {
    description: 'Label shown above this KPI group.',
    type: 'string',
  },
  'items[].color': {
    description: 'Color theme for the KPI group (hex or alias).',
    type: 'string',
  },
  'items[].tooltip': {
    description: 'Tooltip for the KPI group header/value.',
    type: 'string',
  },
  'items[].ignore_zoom': {
    description: 'If true, item value is not affected by current zoom selection.',
    type: 'boolean',
  },
  'items[].values': {
    description: 'Value entries rendered inside one KPI group.',
    type: 'DoubleKpiValueSingleValue[]',
  },
  'items[].values[].type': {
    description: 'Main renders prominently; sub renders secondary text.',
    type: '"main" | "sub"',
  },
  'items[].values[].text': {
    description: 'Optional text label shown next to the value.',
    type: 'string',
  },
  'items[].values[].data_id': {
    description: 'Dataset key. Must match return_id from a DSI.',
    type: 'string',
  },
  'items[].values[].decimals': {
    description: 'Decimal precision for the value.',
    type: 'number',
  },
  'items[].values[].data_type': {
    description: 'Formatting hint (e.g. cost, energy, power).',
    type: 'string',
  },
  'items[].values[].unit': {
    description: 'Optional unit displayed with the value.',
    type: 'string',
  },
  title: {
    description: 'Optional title shown above all KPI groups.',
    type: 'string',
    example: '"__Summary"',
  },
  position: {
    description: 'Horizontal alignment of KPI groups.',
    type: '"center" | "left" | "evenly"',
    example: '"evenly"',
  },
  paddingLeft: {
    description: 'Adds left padding to the component container.',
    type: 'boolean',
  },
  show_date_range: {
    description: 'Shows active dataset date range below values.',
    type: 'boolean',
  },
  applyAggregateOptions: {
    description: 'Custom aggregation behavior for dataset processing.',
    type: 'Record<string, unknown>',
  },
}
